import utils from '../../../utils/utils';

const now = new Date();
const date = new Date(now);
const yearToDate = date.setDate(now.getDate() - 365);

export const fileQueries = {
    importReportCounts: {
        addCount: true,
        limit: 0,
        initialFilter: null,
    },
    importsPerDay: {
        addCount: true,
        groupBy: ['dateToString(added)'],
        limit: 0,
        text: '',
        initialFilter: {
            dateToString_added: {
                type: 'TEMPORAL',
                gte: `${utils.formatDate(yearToDate, 'YYYY-MM-DD')}`,
                lte: `${utils.formatDate(now, 'YYYY-MM-DD')}`,
            },
        },
        where: {},
    },
    importsPerStatus: {
        addCount: true,
        groupBy: ['status'],
        limit: 0,
        where: {},
    },
};

export const caseQueries = {
    casesReportCounts: {
        addCount: true,
        limit: 0,
        text: '',
        initialFilter: {},
        where: {},
    },
    casesPerWorkspace: {
        addCount: true,
        groupBy: ['workspaceId'],
        sortAsc: true,
        limit: 0,
        where: {},
    },
};

export const activityQueries = {
    activityCount: {
        addCount: true,
        limit: 0,
        text: '',
        initialFilter: {},
        where: {},
    },
};

export const allActivityQueries = {
    activityByUser: {
        addCount: true,
        groupBy: ['userId'],
        limit: 0,
        where: {},
    },
    activityByAction: {
        addCount: true,
        groupBy: ['action'],
        limit: 0,
        where: {},
    },
    activityByCollection: {
        addCount: true,
        groupBy: ['collectionName'],
        limit: 0,
        where: {},
    },
    activityByCaseId: {
        addCount: true,
        groupBy: ['caseId'],
        limit: 0,
        where: {},
    },
    activityByWorkspaceId: {
        addCount: true,
        groupBy: ['workspaceId'],
        limit: 0,
        where: {},
    },
};

export const workspaceQueries = {
    workspaceCounts: {
        addCount: true,
        limit: 0,
        fields: ['name'],
        text: '',
        initialFilter: {},
        where: {},
    },
};
